/* ========================================================================= */
/* Custom events */
/* ========================================================================= */

/**
 * @function dispatchEvent
 * @param {string} eventType
 * @param {object} config
 * @param {any} [config.target] - The element on which the dispatch should be executed.
 *
 * Handy function to easily dispatch custom events.
 */
export const dispatchEvent = (eventType, { target = window } = {}) => {
    var customEvent = new CustomEvent(eventType);
    target.dispatchEvent(customEvent);
};

/* ========================================================================= */
/* Delays */
/* ========================================================================= */

/**
 * @function debounce
 * @param {function} callback - the callback to execute.
 * @param {int} delay - the minimal delay between each call before any prevent.
 * @param {boolean} immediate - triggers the function on the leading edge,
 * instead of the trailing.
 *
 * Returns a function, that, as long as it continues to be invoked,
 * will not be triggered.
 */
export const debounce = (callback, delay, immediate = false) => {
    let timeout;
    return function (...args) {
        const callNow = immediate && !timeout;

        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            timeout = null;
            if (!immediate) { callback.apply(this, args); }
        }, delay);

        if (callNow) { callback.apply(this, args); }
    };
};
